/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import {
  Pagination,
  Space,
  Select,
  Input,
  notification,
  Tooltip,
  Spin,
  Popover,
  Button,
  Radio,
  Checkbox
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import refresh from "../../../../assets/images/refresh.svg";
import filter from "../../../../assets/images/filter.svg";
import sort from "../../../../assets/images/sort.svg";
import arrow from "../../../../assets/images/downarrow.svg";
import CustomButton from "views/components/common/button/CustomButton";
import PageGridView from "./PageGridView";
import environment from "environment";
import axios from "axios";
import PageTableview from "./PageTableview";
import { useTranslation } from "react-i18next";
import CommonAction from "stores/common/CommonAction";
import { useDispatch, useSelector } from "react-redux";
import { forceLogout } from "utilities/HttpUtility";



const PageHeader = () => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {currentView} = useSelector((state) => state.common);

  const pageOptions = useSelector((state) => state.common.options);

  const { updation_status, extraction_status } = useSelector(
    (state) => state.common.options
  );
  
  const [tempFilters, setTempFilters] = useState({
    updation_status: null,
    extraction_status: [],
  });

  // Initialize filters from Redux store on component mount
  useEffect(() => {
    setTempFilters({
      updation_status: updation_status || null,
      extraction_status: extraction_status || [],
    });
  }, [updation_status, extraction_status]);


  const [documentList, setDocumentList] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalDocuments, setTotalDocuments] = useState();
  const debounceTimer = useRef(null);

  const handleOnChangeSearch = (e) => {
    const newOptions = {
      ...pageOptions,
      search: e.target.value,
      pageNumber: 1,
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  // const scrollToTarget = () => {
  //   console.log('*** scrollTO');
  //   if (selectedDocument) {
  //   console.log('*** targetElement', currentPosition);
  //   window.scrollTo(0, parseInt(currentPosition, 10));
  //   }
  // }

  const handleOnChangeSort = (e) => {
    const newOptions = {
      ...pageOptions,
      sortOrder: e.target.value,
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const handleOnChangeSortField = (e) => {
    const newOptions = {
      ...pageOptions,
      sortBy: e.target.value,
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const handleTableSortor = (sortValueParam, sortOrderParam) => {
    const newOptions = {
      ...pageOptions,
      sortBy: sortValueParam,
      sortOrder: sortOrderParam,
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const handleOnChangeUpdationStatus = (e) => {
    const updatedStatus = tempFilters.updation_status === e.target.value ? null : e.target.value;
    setTempFilters((prev) => ({
      ...prev,
      updation_status: updatedStatus,
    }));
  };

  const handleOnChangeExtractionStatus = (selectedValues) => {
    setTempFilters((prev) => ({
      ...prev,
      extraction_status: selectedValues,
    }));
  };


  const handleApplyFilters = () => {
    const newOptions = {
      ...pageOptions,
      pageNumber: 1,
      updation_status: tempFilters.updation_status,
      extraction_status: tempFilters.extraction_status,
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const handleClearAll = () => {
    setTempFilters({
      updation_status: null,
      extraction_status: [],
    });

    dispatch(
      CommonAction.setPageOptions({
        ...pageOptions,
        pageNumber: 1,
        updation_status: null,
        extraction_status: [],
      })
    );
  };


  const filtercontainer = (
    <div className="filter-container">
      <div className="border-btm-dark-gray py-2">
        <div className="px-3 py-2 ant-popover-title mb-0">{t("filter")}</div>
      </div>
  
      {/* Filter Row for Status and Quality Level */}
      <div className="filters-row">
        {/* Status Filter */}
        <div className="status-filter">
          <div className="filter-heading">{t("status")}</div>
          <Radio.Group
            className="vertical-radio-group"
            onChange={handleOnChangeUpdationStatus}
            value={tempFilters.updation_status}
          >
            <Radio value="not_yet_started">
              {t("not_yet_started")}
            </Radio>
            <Radio value="in_progress">
              {t("in_progress")}
            </Radio>
            <Radio value="completed">
              {t("completed")}
            </Radio>  
          </Radio.Group>
        </div>
  
        {/* Quality Level Filter */}
        <div className="quality-filter">
          <div className="filter-heading">{t("quality_level")}</div>
          <Checkbox.Group
            options={[
              { label: t("good"), value: "Good" },
              { label: t("verify"), value: "Please Verify Once" },
              { label: t("not_extracted"), value: "Not Extracted" },
            ]}
            value={tempFilters.extraction_status}
            onChange={handleOnChangeExtractionStatus}
          />
        </div>
      </div>
  
      {/* Buttons */}
      <div className="buttons-row">
        <CustomButton
          label={t("apply")}
          // type="primary"
          htmlType="submit"
          className="btn-blue"
          navigate={false}
          key="apply"
          onClick={handleApplyFilters}
          // disabled={
          //   !tempFilters.updation_status && 
          //   (!tempFilters.extraction_status || tempFilters.extraction_status.length === 0)
          // }        
        />
        <CustomButton
          label={t("clear")}
          // type="secondary"
          htmlType="button"
          className="btn-blue"
          navigate={false}
          key="reset"
          onClick={handleClearAll}
          // disabled={
          //   !tempFilters.updation_status && 
          //   (!tempFilters.extraction_status || tempFilters.extraction_status.length === 0)
          // }        
        />
      </div>
    </div>
  );
  
  


  const handleOnRefresh = () => {
    getExtratedDocument();
  };

  const handleAtuoRefreshInterval = () => {
    handleOnRefresh();
  };

  const onChangePageView = (view) => {
    dispatch(CommonAction.setCurrentView(view));
  };

  const handleOnChangeCount = (value) => {
    const newOptions = {
      ...pageOptions,
      pageNumber: 1,
      pageSize: value,
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const handlePagination = (pageNumber, pageSize) => {
    const newOptions = {
      ...pageOptions,
      pageNumber,
      pageSize,
    };
    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const invokeDebouncer = () => {
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      getExtratedDocument();
    }, 300);
  }

  const getExtratedDocument = async () => {
    const { sortBy, sortOrder, pageSize, pageNumber, search, updation_status, extraction_status } = pageOptions;

    try {
      setIsLoading(true);
      let endpoint = `${environment.baseApi}/document?page=${pageNumber}&limit=${pageSize}`;

      if (search) {
        endpoint += `&search=${search}`;
      }

      if (updation_status) {
        endpoint += `&updation_status=${updation_status}`;
      }
      if (extraction_status) {
        endpoint += `&extraction_status=${extraction_status}`;
      }

      if (sortBy && sortOrder) {
        endpoint += `&sortBy=${sortOrder}&sortField=${sortBy}`;
      }

      let payload = {};

      const token = sessionStorage.getItem("authToken");
      const headers = {
        "Content-Type": "application/json",
      };
      if (token) {
        headers.Authorization = token;
      }

      const response = await axios.post(endpoint, payload, {
        headers,
      });

      const dataFromResponse = response.data.result.data.map((item, index) => ({
        file_name: item.file_name,
        last_modified_by: item.assigned_user,
        is_operator_assigned: !!item.assigned_user,
        received_at: item.extracted_at_cet,
        last_modified_at: item.last_modified_at_cet,
        number_of_pages: item.number_of_pages,
        updated_status: item.updation_status,
        key: index.toString(),
        version_history: item.version_history,
        excel_link: item.excel_link,
        id: item.id,
        notes: item.notes,
        sas_excel_link: item.sas_excel_link,
        sas_document_link: item.sas_document_link,
        extraction_status: item.extraction_status,
        recipient: item.general_information
          ? item.general_information["Policyholder Name"]
          : "",
      }));
      setIsLoading(false);
      setData(dataFromResponse);
      setDocumentList(response.data.result.data);
      setTotalDocuments(response.data.result.overallCount);
    } catch (err) {
      if (err.response.status === 401) {
        notification.error({
          message: t("accessDenied"),
          description: t("tokenExpired"),
        });
        forceLogout(err.response.status);
      } else {
        notification.error({
          message: "Document List Error",
          description: err,
        });
      }
    }
  };

  useEffect(() => {
    invokeDebouncer();

    // setTimeout(() => {
    //   scrollToTarget();
    // }, 5000)
  }, [pageOptions]);

  useEffect(() => {
    const intervalId = setInterval(handleAtuoRefreshInterval, 5 * 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [pageOptions]);

  return (
    <>
      <Spin spinning={false} tip="" size="large">
        <>
        <div className="d-flex justify-content-between page-content mt35 mb25">
          <div className="">
            <h1 className="page-extract-heading mb-0 fs26 poppins-semibold">
              {t("PDFExtraction")}
            </h1>
          </div>
          <div className="d-flex align-items-center pb-1">
            {/*<img src={clockIcon} alt="clock icon" />
            <span className="ms-2 fs-14 time-gray">{t("lastUpdate")}: 12:00</span>*/}
          </div>
        </div>
          <div className="page-content">
            <div className="d-flex justify-content-between mb20 p-0 page-content-subheader">
              <div className="d-flex flex-wrap">
                <Space.Compact
                  size="large"
                  className="search-option-header"
                >
                  <Input
                    addonBefore={<SearchOutlined />}
                    placeholder={t("search")}
                    onChange={handleOnChangeSearch}
                    value={pageOptions.search}
                    className="ps-0"
                  />
                </Space.Compact>

                <span className="d-flex">
                  <div className="d-flex flex-row-reverse">
                      <>
                        <Popover
                          placement="bottom"
                          title={t("sortBy")}
                          trigger="click"
                          overlayClassName="sortby-popover"
                          content={
                            <div>
                              <Radio.Group
                                className="horizontal-radio-group"
                                onChange={handleOnChangeSort}
                                value={pageOptions.sortOrder}
                              >
                                <Radio value="ASC">{t("asc")}</Radio>
                                <Radio value="DESC">{t("desc")}</Radio>
                              </Radio.Group>
                              <div>
                                <br />
                                <p>{t("sortFields")}</p>
                                <Radio.Group
                                  className="vertical-radio-group"
                                  onChange={handleOnChangeSortField}
                                  value={pageOptions.sortBy}
                                >
                                  <Radio value={"file_name"}>
                                    {t("documentName")}
                                  </Radio>
                                  <Radio value={"assigned_user"}>
                                    {t("operator")}
                                  </Radio>
                                  <Radio value={"receiver_name"}>
                                    {t("receiver")}
                                  </Radio>
                                  <Radio value={"received_at"}>
                                    {t("extractedAt")}
                                  </Radio>
                                  <Radio value={"last_modified_at"}>
                                    {t("lastModified")}
                                  </Radio>
                                  <Radio value={"number_of_pages"}>
                                    {t("noOfPages")}
                                  </Radio>
                                </Radio.Group>
                              </div>
                            </div>
                          }
                        >
                          <Button className="sort-btn custom-sort-btn">
                            <img src={sort} alt="sort" className="me-2" />
                            <span className="poppins-medium fs14">
                              {t("sortBy")}
                            </span>
                            <img
                              src={arrow}
                              alt="arrow"
                              className="cursor-pointer ms-2"
                            />
                          </Button>
                        </Popover>
                      </>

                      <span className="sort-btn">
                        <Popover
                          placement="bottom"
                          content={filtercontainer}
                          trigger="click"
                        >
                            <img
                              src={filter}
                              alt="filter"
                              className="me-2"
                            />
                            <span className="poppins-medium fs14">{t("filters")}</span>
                        </Popover>
                      </span>
                  </div>
                  <span className="sort-btn rounded-circle pl12 pr12">
                   <Tooltip placement="bottom" title={t("refresh")}>
                      <img
                        src={refresh}
                        alt="refresh"
                        className={`
                          refresh-icon ${
                          isLoading ? "rotate-on-click" : ""
                        }`}
                        onClick={handleOnRefresh}
                      />
                    </Tooltip>
                  </span>
                </span>
              </div>
              <div className="list-dashboard">
                <div className="btn-group-switch">
                 <button className={currentView === "Grid"
                     ? "btn btn-primary"
                     : "btn"} loading="eager" onClick={() => onChangePageView("Grid")}>
                     <svg className="me-2" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 9H16.5M9 1.5V16.5M5.5 1.5H12.5C13.9001 1.5 14.6002 1.5 15.135 1.77248C15.6054 2.01217 15.9878 2.39462 16.2275 2.86502C16.5 3.3998 16.5 4.09987 16.5 5.5V12.5C16.5 13.9001 16.5 14.6002 16.2275 15.135C15.9878 15.6054 15.6054 15.9878 15.135 16.2275C14.6002 16.5 13.9001 16.5 12.5 16.5H5.5C4.09987 16.5 3.3998 16.5 2.86502 16.2275C2.39462 15.9878 2.01217 15.6054 1.77248 15.135C1.5 14.6002 1.5 13.9001 1.5 12.5V5.5C1.5 4.09987 1.5 3.3998 1.77248 2.86502C2.01217 2.39462 2.39462 2.01217 2.86502 1.77248C3.3998 1.5 4.09987 1.5 5.5 1.5Z" stroke="#98A2B3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>{t("board")}</button>
                 <button className={currentView === "List"
                     ? "btn btn-primary"
                     : "btn"} loading="eager" onClick={() => onChangePageView("List")}>
                     <svg className="me-2" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.5833 13.1667H4.41667M13.5833 9.83333H4.41667M1.5 6.5H16.5M5.5 1.5H12.5C13.9001 1.5 14.6002 1.5 15.135 1.77248C15.6054 2.01217 15.9878 2.39462 16.2275 2.86502C16.5 3.3998 16.5 4.09987 16.5 5.5V12.5C16.5 13.9001 16.5 14.6002 16.2275 15.135C15.9878 15.6054 15.6054 15.9878 15.135 16.2275C14.6002 16.5 13.9001 16.5 12.5 16.5H5.5C4.09987 16.5 3.3998 16.5 2.86502 16.2275C2.39462 15.9878 2.01217 15.6054 1.77248 15.135C1.5 14.6002 1.5 13.9001 1.5 12.5V5.5C1.5 4.09987 1.5 3.3998 1.77248 2.86502C2.01217 2.39462 2.39462 2.01217 2.86502 1.77248C3.3998 1.5 4.09987 1.5 5.5 1.5Z" stroke="#98A2B3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>{t("table")}</button>
                </div>
              </div>
              </div>
            </div>
            <div className="page-content-subheader mt-3">
            {currentView === "Grid" ? (
              <PageGridView extrated_data={documentList} />
            ) : (
              <PageTableview
                data={data}
                handler={handleTableSortor}
              />
            )}
            </div>
          <div className="page-footer d-flex justify-content-between pb10 align-items-center pl40 pr40">
            <div className="">
              <span className="text-gray-e fs12 poppins-medium">{t("showing")}:</span>
              <Select
                defaultValue="10"
                value={pageOptions.pageSize}
                style={{ width: 65, height: 25 }}
                onChange={handleOnChangeCount}
                options={[
                  { value: 5, label: "5" },
                  { value: 10, label: "10" },
                  { value: 20, label: "20" },
                  { value: 100, label: "100" },
                ]}
                className=""
              />
              <span className="time-gray fs12">{t('of')} {totalDocuments}</span>
            </div>
            <div className="">
              <Pagination
                current={pageOptions.pageNumber}
                total={totalDocuments}
                pageSize={pageOptions.pageSize}
                onChange={(page, pageSize) => handlePagination(page, pageSize)}
                showSizeChanger={false}
                responsive={true}
              />
            </div>
          </div>
        </>
      </Spin>
    </>
  );
};

export default PageHeader;
